module.exports = __webpack_public_path__ + "static/media/ios-paper.d549c676.svg";